import { useAuth } from "@/context/AuthContext";

/**
 * v1.27.75 — Central "can this user delete?" gate. Company Admin and
 * Super User can delete; staff sub-users (any staff_permission) never can.
 * The backend enforces the same rule in `require_admin`, so hiding the
 * button in the UI is defence-in-depth + clarity for the user.
 */
export default function useCanDelete() {
    const { user } = useAuth();
    if (!user) return false;
    if (user.is_super_user) return true;
    return user.role === "admin";
}
